import $ from 'jquery';
import pubSub from './pubSub';
import { initFilterTags } from './filter';
import initArticleListOrder from './article-list-order';
import spinnerUtils from './spinner';

/**
 * @param  {Node} scope the scope in which to search for articles to reload
 * @return {void}
 */
export default function initPagination(scope = document) {
  $(scope).find('.pagination .btn').on('click', (event) => {
    event.preventDefault();
    const element = $(event.currentTarget);
    const url = $(element).attr('href');
    const token = spinnerUtils.create();

    // send with 'partial' param to get the content for ajax injection into the DOM
    $.get(url, { partial: '1' }, (data) => {
      if (data.length > 0) {
        const container = $(element).closest('.load-more-content');
        const oldArticles = $(container).find('.load-more-teaser').first().html();

        $(container).html(data);

        const newArticles = $(container).find('.load-more-teaser').first().html();

        $(container).find('.load-more-teaser').first().html(oldArticles + newArticles);

        initFilterTags(document.querySelector('.delete-option'));
        initPagination(container);
        initArticleListOrder(container);

        pubSub.publish('reloaded.content', {
          scope: container[0],
        });
      }

      // destroy spinner
      spinnerUtils.destroy(token);
    });

    return false;
  });

  $(scope).find('.listLocator').on('click', (event) => {
    const element = event.currentTarget;
    const url = $(element).attr('href');
    const token = spinnerUtils.create();

    // send with 'partial' param to get the content for ajax injection into the DOM
    $.get(url, { partial: '1' }, (data) => {
      if (data.length > 0) {
        const container = $(element).closest('.load-more-content');
        $(container).html(data);

        initFilterTags(document.querySelector('.delete-option'));
        initPagination(container);
        initArticleListOrder(container);

        pubSub.publish('reloaded.content', {
          scope: container[0],
        });
      }

      // destroy spinner
      spinnerUtils.destroy(token);
    });

    return false;
  });
}

initPagination();



// WEBPACK FOOTER //
// ./assets/js/components/pagination.js